import { MuiRootProps } from "types/mui"
import { Dusk, Midnight } from "./colours"

/**
 * - Styles override to MUISelect to match Vacasa owner onboarding design
 */
const muiSelect = {
    styleOverrides: {
        root: ({ theme }: MuiRootProps) => ({
            borderRadius: theme.spacing(1),
            border: `1px solid ${Midnight[10]}`,
            height: theme.spacing(5),
            width: "240px",
            color: Dusk[100],
            ...theme.typography.bodySemiBold,
            ".MuiSelect-select": {
                width: "calc(100% - 50px)",
            },
        }),
    },
}

export default muiSelect
